import React, { useRef, useCallback } from "react";
import useFetchRiderAssignmentById from "../Libs/useFetchRiderAssignmentById";
import Spinner from "../../utils/spinner";
import { Link } from "react-router-dom";
import "./Rider_assignment.css";

const Rideraccepted = () => {
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
  } = useFetchRiderAssignmentById();

  const observerRef = useRef();
  const lastRiderAssignmentElementRef = useCallback(
    (node) => {
      if (isFetchingNextPage) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  const filteredAssignments = Array.isArray(data?.pages)
    ? data.pages.flatMap((page) =>
        Array.isArray(page?.riderAssignments)
          ? page.riderAssignments.filter(
              (assignment) =>
                Array.isArray(assignment.accept) && assignment.accept.length > 0
            )
          : []
      )
    : [];

  return (
    <div className="assignment-link">
      {isLoading && <Spinner />}
      {isError && (
        <p style={{ fontFamily: "Montserrat" }}>Error: {error.message}</p>
      )}

      <div className="card">
        {!isLoading && !isError && (
          <>
            {filteredAssignments.length === 0 ? (
              <p style={{ fontFamily: "Montserrat" }}>
                No matching assignments found.
              </p>
            ) : (
              filteredAssignments.map((assignment, index) => {
                const isLast = index === filteredAssignments.length - 1;
                const receiver = assignment.package?.[0]?.receiver;
                const items = assignment.package?.[0]?.items;

                return (
                  <div
                    key={assignment._id}
                    ref={isLast ? lastRiderAssignmentElementRef : null}
                  >
                    <Link to={`/details/${assignment._id}`}>
                      <h3>ID {assignment._id.slice(0, 8).toUpperCase()}</h3>
                      <h2>Receiver: {receiver?.name || "N/A"}</h2>
                      <span>
                        {Array.isArray(items)
                          ? items.map((item) => (
                              <div key={item?._id}>
                                {item?.name} - {item?.quantity}
                              </div>
                            ))
                          : "N/A"}
                      </span>
                      <p>
                        {receiver?.state || "Unknown"},{" "}
                        {receiver?.address_1 || "Unknown Address"}
                      </p>
                      <h3>
                        Receiver Phone Number: {receiver?.phone_number || "N/A"}
                      </h3>
                      <h3>
                        Receiver Secret Pin:{" "}
                        {assignment?.package?.[0]?.secretPin || "N/A"}
                      </h3>
                    </Link>
                  </div>
                );
              })
            )}
          </>
        )}
      </div>

      {isFetchingNextPage && <Spinner />}
    </div>
  );
};

export default Rideraccepted;
